var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "gobierto-autocomplete" },
    [
      _vm.label.length
        ? _vm._t("label", [
            _c(
              "label",
              {
                staticClass: "gobierto-autocomplete__label",
                attrs: { for: "autocomplete-input" }
              },
              [_vm._v("\n      " + _vm._s(_vm.label) + "\n    ")]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.search,
            expression: "search"
          }
        ],
        staticClass: "gobierto-autocomplete__input",
        class: { "is-active": _vm.isOpen },
        attrs: {
          id: "autocomplete-input",
          name: _vm.name,
          autocomplete: "off",
          placeholder: _vm.placeholder,
          type: "text"
        },
        domProps: { value: _vm.search },
        on: {
          input: [
            function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.search = $event.target.value
            },
            _vm.onChange
          ],
          keydown: [
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "down", 40, $event.key, [
                  "Down",
                  "ArrowDown"
                ])
              ) {
                return null
              }
              return _vm.onArrowDown($event)
            },
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
              ) {
                return null
              }
              return _vm.onArrowUp($event)
            },
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              $event.preventDefault()
              return _vm.setResult()
            }
          ],
          dblclick: function($event) {
            _vm.isOpen = !_vm.isOpen
          }
        }
      }),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide" } }, [
        _vm.isOpen
          ? _c(
              "ul",
              { staticClass: "gobierto-autocomplete__results" },
              _vm._l(_vm.results, function(result, i) {
                return _c(
                  "li",
                  {
                    key: i,
                    staticClass: "gobierto-autocomplete__result",
                    class: { "is-active": i === _vm.arrowCounter },
                    on: {
                      click: function($event) {
                        return _vm.setResult(result)
                      }
                    }
                  },
                  [
                    _vm._t(
                      "default",
                      [_vm._v("\n          " + _vm._s(result) + "\n        ")],
                      { result: result }
                    )
                  ],
                  2
                )
              }),
              0
            )
          : _vm._e()
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }